import { render } from "./GoalDetail.vue?vue&type=template&id=304583b7&scoped=true&ts=true"
import script from "./GoalDetail.vue?vue&type=script&lang=ts"
export * from "./GoalDetail.vue?vue&type=script&lang=ts"

import "./GoalDetail.vue?vue&type=style&index=0&id=304583b7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304583b7"]])

export default __exports__